import React, { useState } from 'react';

const RoundSpecialDetails = ({ matches }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className={`table-responsive m-t-30 round-special-timeline-table ${isOpen ? 'open' : ''}`}>
      <table className="match">
        <thead className="thead--green">
          <tr>
            <th>Total Goals</th>
            <th>Total Home Goals</th>
            <th>Total Away Goals</th>
            <th>Minute</th>
            <th>Match Score</th>
            <th className="has-dropdown" onClick={() => setIsOpen(prev => !prev)} />
          </tr>
        </thead>
        <tbody id="roundSpecialTimelineBody">
          {matches.map((match) => (
            <tr key={match.matchMinute}>
              <td>{match.totalScorePerMinute}</td>
              <td>{match.totalHomeGoals}</td>
              <td>{match.totalAwayGoals}</td>
              <td>{match.matchMinute}&apos;</td>
              <td colSpan="2">
                {match.matches.map((m) => (
                  <div key={m.matchId} className="round-special team-container">
                    <div className="home-team">{m.homeTeam}</div>
                    <div className="score">{m.homeScore} - {m.awayScore}</div>
                    <div className="away-team">{m.awayTeam}</div>
                  </div>
                ))}
              </td>
            </tr>))
          }
        </tbody>
      </table>
    </div>
  );
};

export default RoundSpecialDetails;